import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  "data-slot": "icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5.812 9a15.001 15.001 0 0 0-2.655 2.556A.703.703 0 0 0 3 12m2.812 3a15 15 0 0 1-2.655-2.556A.703.703 0 0 1 3 12m0 0h13m-5-7.472A6 6 0 0 1 21 9v6a6 6 0 0 1-10 4.472"
    }, null, -1)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "logout"}) } }